import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { Alert, Button, Card } from "../../../components/ui";
import { AppShell } from "../../../layouts/AppShell";
import { downloadMaterialFile, getMaterial } from "../api/materialApi";

export function MaterialDetailPage() {
  const { materialId = "" } = useParams();
  const [error, setError] = useState<string>();
  const query = useQuery({
    queryKey: ["material", materialId],
    queryFn: () => getMaterial(materialId),
    enabled: Boolean(materialId),
  });
  const material = query.data;

  const download = async () => {
    if (!material?.currentVersion) return;
    try {
      const result = await downloadMaterialFile(
        material.id,
        material.currentVersion.id,
      );
      const url = URL.createObjectURL(result.blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = result.filename;
      document.body.append(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "下載暫時無法使用");
    }
  };

  return (
    <AppShell
      title={material?.title ?? "教材內容"}
      breadcrumb={["教材", material?.title ?? "教材內容"]}
    >
      {error && <Alert variant="danger">{error}</Alert>}
      <Card title={material?.title}>
        {material && (
          <>
            <p>{material.description}</p>
            {material.currentVersion && (
              <Button onClick={() => void download()}>
                下載 {material.currentVersion.filename}
              </Button>
            )}
          </>
        )}
      </Card>
    </AppShell>
  );
}
